import React, { useEffect, useState } from 'react';

import Spinner from '../../components/Spinner';
import { getCompanyList } from '../OpeningHours/getCompanies';
import ErrorMessage from '../AccommodationSearch/components/ErrorMessage';

const OpeningHoursSingle = () => {
  const [companies, setCompanies] = useState();

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState();

  useEffect(() => {
    async function fetchCompanies() {
      const companyList = await getCompanyList(drupalSettings.companies);

      if (companyList) {
        setCompanies(companyList);
      } else {
        setError(Drupal.t('Error fetching opening hours'));
      }
      setIsLoading(false);
    }

    if (drupalSettings.companies) {
      fetchCompanies();
    } else {
      setError(Drupal.t('Error fetching opening hours'));
      setIsLoading(false);
    }
  }, []);

  return (
    <div className="opening-hours-single">
      {companies ?? ''}

      {isLoading && <Spinner />}

      {error && <ErrorMessage message={error} />}
    </div>
  );
};

export default OpeningHoursSingle;
